<template>
  <v-card class="support-ended-card pa-6" elevation="0" outlined rounded="xl">
    <div class="text-center">
      <v-icon color="success" size="48" aria-hidden="true">mdi-check-circle-outline</v-icon>
      <h1 class="text-h5 font-weight-bold mt-4 mb-2">Support session ended</h1>
      <p class="text-body-2 mb-4">Temporary customer access has been removed. You can safely close this tab.</p>
      <v-btn color="primary" min-height="44" @click="closeTab">Close this tab</v-btn>
      <p v-if="closeFailed" class="text-caption mt-3 mb-0" role="status">Your browser did not close the tab. You can close it manually.</p>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "BackOfficeSupportEnded",
  data: () => ({ closeFailed: false }),
  methods: {
    closeTab() {
      window.close();
      window.setTimeout(() => { this.closeFailed = true; }, 300);
    },
  },
};
</script>

<style scoped>
.support-ended-card { max-width: 460px; width: 100%; }
</style>
